module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/hoodie/5-2224106433650e655ea6de12bed80f3b.jpg";